export interface AOAuthProviderInterface {

  login(data: any): Promise<any>;

  logout(): Promise<any>;

  update(data: any): Promise<any>;

  forgetPassword(data: any): Promise<any>;

  resetPassword(data: any): Promise<any>;

  updatePassword(data: any): Promise<any>;

}
